module.exports = __webpack_public_path__ + "img/banner_2026_nyuukai.60c59fdb.jpg";